import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class UserSearchParams extends SearchParamsBase {
  initialize() {
    this.Id = '';
    this.Name = '';
    this.Email = '';
    this.OfficeId = '';
    this.IsActive = 'true';
    this.UserName = '';
    this.SupervisorId = '';
    this.DepartmentId = '';
    this.OfficialJobTitleId = '';
    this.WorkforceType = '';
    this.GroupIds = [];
  }

  static defaultOfficeId = '';

  static ConvertToJSON(originalSearchItem) {
    const correctedSearchItem = { ...originalSearchItem };
    for (const prop in correctedSearchItem) {
      correctedSearchItem[prop] = correctedSearchItem[prop].toString();
    }
    return JSON.stringify(correctedSearchItem);
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    { fieldName: 'UserName', label: 'Username', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'Name', label: 'Name', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'Email', label: 'Email', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'Id', label: 'ID', className: 'col-4', type: InputTypesEnum.Number },
    { fieldName: 'OfficeId', label: 'Office', className: 'col-4', type: InputTypesEnum.OfficeOrGroupSelect },
    { fieldName: 'IsActive', label: 'IsActive', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'SupervisorId', label: 'Supervisor', className: 'col-4', type: InputTypesEnum.UserSelect },
    {
      fieldName: 'OfficialJobTitleId',
      label: 'Job Title',
      className: 'col-4',
      type: InputTypesEnum.OfficialJobTitleLookupItemSelect,
    },
    {
      fieldName: 'DepartmentId',
      label: 'Department',
      className: 'col-4',
      type: InputTypesEnum.DepartmentLookupItemSelect,
    },
    {
      fieldName: 'WorkforceType',
      label: 'Workforce type',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: UserSearchParams.WorkforceTypeSelectOptions(),
    },
    { fieldName: 'GroupIds', label: 'Groups', className: 'col-4', type: InputTypesEnum.ActiveGroupMultiChoice },
  ];

  static WorkforceTypeSelectOptions() {
    return [
      { label: 'Choose one...', value: '', disabled: true },
      { label: 'Employee', value: 'Employee', disabled: false },
      { label: 'Contractor', value: 'Contractor', disabled: false },
      { label: 'Student', value: 'Student', disabled: false },
    ];
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'UserSearchParams';
}
